import { useTranslation } from 'react-i18next';
import { Badge, BadgeProps } from '@anyui/core';
import { MarketplaceCampaignParticipateStatus } from '@anytag/graphql';

export interface MarketplaceParticipateInfluencerStatusProps {
  className?: string;
  status: MarketplaceCampaignParticipateStatus;
}

export const MarketplaceParticipateInfluencerStatus = ({
  status,
  className
}: MarketplaceParticipateInfluencerStatusProps) => {
  const { t } = useTranslation();

  const statusProps: BadgeProps = (() => {
    switch (status) {
      case MarketplaceCampaignParticipateStatus.JOINED:
        return { children: t('Option.Joined'), color: 'blue' };
      case MarketplaceCampaignParticipateStatus.REJECTED:
        return { children: t('Option.Rejected'), color: 'red' };
      case MarketplaceCampaignParticipateStatus.WAITING:
        return { children: t('Option.Waiting'), color: 'cyan' };
      case MarketplaceCampaignParticipateStatus.APPLIED:
        return { children: t('Option.Applied'), color: 'yellow' };
      case MarketplaceCampaignParticipateStatus.UNAVAILABLE:
        return { children: t('Option.Unavailable'), color: 'zinc' };
      case MarketplaceCampaignParticipateStatus.REVIEWING:
        return { children: t('Option.Reviewing'), color: 'purple' };
      case MarketplaceCampaignParticipateStatus.AVAILABLE:
      default:
        return { children: t('Option.Available'), color: 'purple' };
    }
  })();

  return <Badge className={className} {...statusProps} />;
};
